import { useEffect, useState } from "react";
import FlightDepartureComponent from "../components/FlightDepartureComponent";
import type { FlightArrival, FlightDeparture } from "../my-type";
import Header from "../layouts/Header";
import { useNavigate } from "react-router-dom";
import { Tabs, VStack } from "rsuite";
import { getFlightArrivalInfo, getFlightDepartureInfo } from "../service/TDXService";
import FlightArrivalComponent from "../components/FlightArrivalComponent";


export default function FlightInfoPage() {

  const [flightDepartures, setFlightDepartures] = useState<FlightDeparture[]>([]);
  const [flightArrivals, setFlightArrivals] = useState<FlightArrival[]>([]);

  const [step, setStep] = useState<number>(0);
  const navigate = useNavigate();



  useEffect(() => {

    const toGetFlightDepartureInfo = async () => {
      if (flightDepartures.length === 0) {
        let departures = await getFlightDepartureInfo("TPE");
        if (departures) {
          setFlightDepartures(departures);
        }
      }
    }

    const toGetFlightArrivalInfo = async () => {
      if (flightArrivals.length === 0) {
        let arrivals = await getFlightArrivalInfo("TPE");
        if (arrivals) {
          setFlightArrivals(arrivals);
        }
      }
    }

    toGetFlightDepartureInfo();
    toGetFlightArrivalInfo();

  }, [])

  const doNavigate = () => {
    switch (step) {
      case 0:
        navigate("/");
        break;
      case 1:
        setStep(0);
        break;
      default:
        break;
    }
  }


  return (<div className="App">
    <Header HeaderTitle={"即時航班資訊"} isShowRefresh={false} OnReturn={doNavigate} OnRefresh={() => { }} />
    <br></br>
    <br></br>
    <br></br>
    <br></br>

    <Tabs defaultActiveKey="1" appearance="pills">
      <Tabs.Tab eventKey="1" title="出境">
        <VStack spacing={10}>
          {flightDepartures.map((flightInfo, index) => {
            return <FlightDepartureComponent key={index} flightDeparture={flightInfo} />
          })}
        </VStack>
      </Tabs.Tab>
      <Tabs.Tab eventKey="2" title="入境">
        <VStack spacing={10}>
          {flightArrivals.map((flightInfo, index) => {
            return <FlightArrivalComponent key={index} flightArrival={flightInfo} />
          })}
        </VStack>
      </Tabs.Tab>
    </Tabs>

  </div>
  )
}
